import React from 'react';
import {translate} from '../../helpers/base';

const RoomHeader = ({index, handleRemoveRoom}) => (
    <div className="booking-box--room-item-header">
        <div className="h5">
            {translate('booking-box.room')} <span>{index + 1}</span>
        </div>
        {index > 0 && (
            <button
                type="button"
                title={translate('booking-box.rooms.removeRoom')}
                className="btn btn-sm btn-delete"
                onClick={() => handleRemoveRoom(index)}
            >
                <i className="icon icon--diverses-delete">
                    <svg
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 30 30"
                    >
                        <path
                            d="M6.68224 11.3347V22.9833C6.68224 25.1925 8.46349 27 10.6406 27H18.4583C20.6354 27 22.4166 25.1925 22.4166 22.9833V11.3347M12.5207 14.1465V20.7741M16.479 14.1465V20.7741M5 6.91631H24M10.7396 6.91632V4.00418C10.7396 3.40167 11.1355 3 11.7292 3H17.3698C17.9636 3 18.3594 3.40167 18.3594 4.00418V6.91632"
                            stroke="black"
                            strokeWidth="2"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                        />
                    </svg>
                </i>
            </button>
        )}
    </div>
);

const NumberPicker = ({label, value, onChange}) => (
    <div className="form-group numberpicker">
        <label>{label}</label>
        <input type="text" value={value} readOnly/>
        <div className="numberpicker-wrapper">
            <button type="button" data-type="subtract" onClick={() => onChange(-1)}>
                <i></i>
            </button>
            <button type="button" data-type="add" onClick={() => onChange(1)}>
                <i></i>
            </button>
        </div>
    </div>
);

const ChildAgeSelectors = ({room, roomIndex, handleChildAgeChange}) => (
    <div className="children-age cols cols--4">
        {room.childAges.map((age, childIndex) => (
            <div key={childIndex} className="form-group">
                <label htmlFor={`childAges${roomIndex}-${childIndex}`}>{translate('booking-box.child')} {childIndex + 1}</label>
                <select
                    id={`childAges${roomIndex}-${childIndex}`}
                    name={`childAges${roomIndex}-${childIndex}`}
                    value={age}
                    onChange={(e) => handleChildAgeChange(roomIndex, childIndex, parseInt(e.target.value, 10))}
                >
                    {Array.from({length: 17}, (_, i) => (
                        <option key={i} value={i}>{i} {translate('booking-box.children.ageSuffix')}</option>
                    ))}
                </select>
            </div>
        ))}
    </div>
);

const RoomItem = ({room, index, handleRemoveRoom, handleAdultsChange, handleChildrenChange, handleChildAgeChange}) => (
    <div className="booking-box--room-item">
        <RoomHeader index={index} handleRemoveRoom={handleRemoveRoom}/>
        <div className="cols cols--2">
            <NumberPicker
                label={translate('booking-box.adults.label')}
                value={room.adults}
                onChange={(delta) => handleAdultsChange(index, delta)}
            />
            <NumberPicker
                label={translate('booking-box.children.label')}
                value={room.children}
                onChange={(delta) => handleChildrenChange(index, delta)}
            />
            <ChildAgeSelectors
                room={room}
                roomIndex={index}
                handleChildAgeChange={handleChildAgeChange}
            />
        </div>
    </div>
);

export default RoomItem;